var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-header-subscription"},[_c('header-steps',{attrs:{"steps":_vm.steps,"route":_vm.route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }